'use client';

import { PropsWithChildren, ReactNode, useRef } from 'react';

import { useIntersectionObserver } from '@monoimin/hooks';

type IntersectionObserverWrapperProps = PropsWithChildren<{
  className?: string;
  observerParams?: Parameters<typeof useIntersectionObserver>['1'];
  placeholder?: ReactNode;
  dataTestId?: string;
}>;

const DEFAUlT_PARAMS = {
  threshold: 0,
  freezeOnceVisible: true,
  rootMargin: '0px 0px 1000px 0px',
};

export const IntersectionObserverWrapper = ({
  className,
  children,
  observerParams = DEFAUlT_PARAMS,
  placeholder,
  dataTestId,
}: IntersectionObserverWrapperProps) => {
  const ref = useRef(null);

  const entry = useIntersectionObserver(ref, observerParams);

  return (
    <div ref={ref} className={className} data-testid={dataTestId}>
      {entry?.isIntersecting ? children : placeholder}
    </div>
  );
};

export default IntersectionObserverWrapper;
